import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "漫糖韩漫上的韩漫真的可以免费看吗?",
    a: "是的。漫糖韩漫为您推荐的免费韩漫均来自公开渠道,您可以通过官方或授权渠道免费阅读。我们会优先整理免费可看的优质作品,方便大家追更不花钱。",
  },
  {
    q: "免费韩漫排行榜多久更新一次?",
    a: "人气排行榜与高分榜单每日实时更新,综合读者人气、评分与口碑进行排序,确保你看到的永远是最新的人气推荐。",
  },
  {
    q: "如何按题材快速找到想看的分类?",
    a: "我们整理了甜宠、奇幻、剧情、悬疑、校园、恋爱、热血、治愈八大热门分类。你可以进入「热门分类」页面,按题材浏览对应的高分榜单与人气推荐。",
  },
  {
    q: "「编辑精选」和普通榜单有什么区别?",
    a: "普通榜单以人气和评分数据为准,实时更新;而「编辑精选」是编辑团队亲自追读、反复打磨后的人工推荐,更注重剧情、画风与后劲,适合想要更高质量选择的朋友。",
  },
  {
    q: "我喜欢的作品没有上榜,可以推荐给平台吗?",
    a: "当然可以!我们非常欢迎读者投稿与反馈。你可以通过「联系我们」页面提供的邮箱或公众号,把喜欢的作品推荐给我们,我们会评估并纳入榜单。",
  },
  {
    q: "作品版权归谁所有?我可以在这里下载漫画吗?",
    a: "漫糖韩漫仅做作品推荐与榜单整理,所有作品的版权均归原作者与版权方所有。我们建议大家通过官方授权渠道阅读,支持正版创作者。",
  },
  {
    q: "分类页和排行榜页的作品有什么区别?",
    a: "排行榜页汇集全站人气高分作品,可按评分、人气或收藏排序,适合「不知道看什么」时逛一逛;分类页则按题材细分,适合有明确口味偏好的读者精准寻找。",
  },
];

export default function Faq() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-foreground-950">
        <div className="mx-auto max-w-4xl px-4 pb-12 pt-24 md:px-6 md:pt-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-400">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-200">常见问题</span>
          </nav>
          <div className="mt-5 text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-sm text-background-200">
              <i className="ri-question-line text-accent-400"></i>
              常见问题
            </span>
            <h1 className="mt-5 font-heading text-3xl text-background-50 md:text-5xl">你想知道的,都在这里</h1>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-300">
              关于免费韩漫、排行榜与分类的常见问题,集中解答。如果仍有疑问,欢迎联系我们。
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:px-6">
        <div className="space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group rounded-2xl border border-background-200/70 bg-background-100 px-5 py-4">
              <summary className="flex cursor-pointer items-center justify-between gap-3 text-base font-bold text-foreground-950">
                {f.q}
                <i className="ri-add-line text-xl text-primary-600 transition-transform group-open:rotate-45"></i>
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border border-background-200/70 bg-background-100 p-8 text-center">
          <h2 className="font-heading text-2xl text-foreground-950">还有问题没解决?</h2>
          <p className="mt-2 text-sm text-foreground-600">随时联系我们,我们会尽快为你解答。</p>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/about" className="flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600">
              <i className="ri-mail-send-fill"></i>
              联系我们
            </Link>
            <Link to="/ranking" className="flex items-center gap-2 rounded-full border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-50">
              去逛排行榜
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}